<template>
  <div :class="`card card-${colorScheme}`">
    <div v-if="hasSlot('card-header')" class="card-header" :class="{ 'p-b-0': !hasHeaderPadding }">
      <slot name="card-header" />
    </div>

    <div v-if="hasSlot('default')" class="card-body card-padding">
      <label v-if="label" class="label-lg">
        {{ label }}
      </label>

      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseCard',

  props: {
    hasHeaderPadding: {
      type: Boolean,
      required: false,
      // eslint-disable-next-line vue/no-boolean-default -- Baseline eslint ignore please fix if working on this
      default: true,
    },

    label: {
      type: String,
      required: false,
      default: null,
    },

    colorScheme: {
      type: String,
      default: 'gray',
    },
  },

  methods: {
    hasSlot(name) {
      return !!this.$slots[name]
    },
  },
}
</script>
